import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import NotFoundView from './404.view';

const notFoundRoute: ViewRouteConfig = {
  element: <NotFoundView />,
  path: '*',
};

export default notFoundRoute;
